import React from 'react'
import BackToUp from '@uiw/react-back-to-top';
import Ban from '../components/Desktop3/ban/Ban'
import HopCategory from '../components/Desktop5/hop_category/HopCategory';
import SetNext from '../components/Desktop6/next/SetNext';


const Desktop6 = () => {
  return (
    <>
     <Ban/>
      <HopCategory/>
      <SetNext/>
      <div className="container">
        <BackToUp><i class="fa-solid fa-arrow-up"></i></BackToUp>
      </div>
    </>
  )
}

export default Desktop6